import React from 'react';
import { CtaButton } from './CtaButton';
export function Footer() {
  return <footer className="bg-lilac-500 py-14 text-center text-white" data-id="element-65" data-mp="3gf96f0gd6eb2">
      <div className="mx-auto max-w-2xl px-5" data-id="element-66" data-mp="3ggka709t7m26">
        <p className="font-display text-2xl font-extrabold sm:text-3xl" data-id="element-67" data-mp="32oe1fz8zkhcr">
          My Magical World of Paper
        </p>
        <p className="mt-3 text-sm text-lilac-100" data-id="element-68" data-mp="36qhdaozkhnyk">
          150+ printable paper dolls · 30 magical themes · 3 FREE bonuses — yours for a one-time
          payment of $27.
        </p>
        <div className="mt-6" data-id="element-69" data-mp="38zawx2kd95j">
          <CtaButton size="md" className="ring-white/30" data-id="element-70" data-mp="37xxwn1zmcl6">
            Yes! Give me the complete kit for $27 →
          </CtaButton>
        </div>
        <p className="mt-8 text-xs text-lilac-200" data-id="element-71" data-mp="3qd6rjf2xfuzg">
          © {new Date().getFullYear()} My Magical World of Paper. Digital product — nothing will
          be shipped.
        </p>
      </div>
    </footer>;
}